import { render, staticRenderFns } from "./FrequencyStep.vue?vue&type=template&id=06881800&scoped=true"
import script from "./FrequencyStep.vue?vue&type=script&lang=js"
export * from "./FrequencyStep.vue?vue&type=script&lang=js"
import style0 from "./FrequencyStep.vue?vue&type=style&index=0&id=06881800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06881800",
  null
  
)

export default component.exports